import { FrameProduct, Product, ProductionMaterialType } from '../';

export function IsProductWithSameMaterial(material?: ProductionMaterialType) {
  return function(product: Product): product is FrameProduct {
    return material === product.productionMaterialType;
  }
}
